<template>
  <div class="bg-body min-h-dvh flex-col">
    <!-- Header -->
    <header class="border-divider bg-card-color border-b">
      <div class="mx-auto flex max-w-5xl items-center justify-between gap-4 px-6 py-4">
        <RouterLink to="/" class="font-wasa c-header-text-color font-700 text-lg">Caplena Survey</RouterLink>

        <NTag size="small" :bordered="false">{{ version }}</NTag>
      </div>
    </header>

    <!-- Page content -->
    <main class="mx-auto w-full max-w-5xl flex-1 px-6 py-8">
      <slot />
    </main>
  </div>
</template>

<script setup lang="ts">
import { RouterLink } from 'vue-router'

defineOptions({
  name: 'DefaultLayout',
})

const version = import.meta.env.CAPP_VERSION
</script>
